import {useCallback} from 'react';
import { LegacyStack, Button, Text } from "@shopify/polaris";
import {useAppBridge} from '@shopify/app-bridge-react';

export function CollectionPicker ({ field, label, form, handleChange, errors }) {
    const shopify = useAppBridge();

    const activate = useCallback(async () => {
        const current = form.configuration[field];
        const selection = await shopify.resourcePicker({
            type: 'collection',
            multiple: false,
            selectionIds: current.id ? [{ id: current.id }] : [],
        });

        if (selection) {
            const [item = { id: '', title: '' }] = selection;
            handleChange({ id: item.id, title: item.title }, `configuration.${field}`);
        }
    }, [form.configuration[field], shopify]);

    const activator = !form.configuration[field].id
        ? (<Button onClick={activate}>Choose {label}</Button>)
        : (
            <div>
                <Text variant="bodyMd" as="span" fontWeight="semibold">{label}</Text>: {form.configuration[field].title} (<Button onClick={activate} size='slim' variant="plain">change</Button>)
            </div>
        );

    return (
        <LegacyStack vertical>
            {activator}
        </LegacyStack>
    );
}
